import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "submit"];

  declare readonly checkboxTargets: HTMLInputElement[];
  declare readonly submitTarget: HTMLButtonElement;

  connect() {
    this.toggleSubmit();
    // Use a listener on the whole form to ensure we don't miss any checks
    this.element.addEventListener('change', () => this.toggleSubmit());
  }

  toggleSubmit() {
    if (!this.hasSubmitTarget) return;

    const anyChecked = this.checkboxTargets.some((checkbox) => checkbox.checked);
    this.submitTarget.disabled = !anyChecked;
  }
}